module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_form":"Select form"},"id":{"select_form":"Pilih form"}}')
  delete Component.options._Ctor
}
